import { API_ENDPOINT } from 'endpoints';
import CelebrationSDK from '@nackle/celebration-sdk';

export default function CelebrationService( { access_token, claims } = {} ) {

    const fetchWithAuth = function ( url, options = {} ) {
        options = {
            ...options,
            headers: {
                ...( options.headers || {} ),
                'authorization': `Bearer ${ access_token }`
            }
        };
        return fetch( url, options );
    };

    const sdk = new CelebrationSDK( API_ENDPOINT, fetchWithAuth, null, claims?.company_id, null );

    return {
        getCelebrationConfigs: sdk.getConfigs,
        getCelebrationConfigById: sdk.getConfig,
        editCelebrationConfig: sdk.updateConfig,
        createCelebrationConfig: sdk.createConfig,
        searchCelebrationType: sdk.searchTypes,
        deleteCelebrationConfig: sdk.deleteConfig,
    };
}
